import { TableContainer, TableContainerProps } from "@mui/material";

/**
 * {@link ReportTableContainer} のデフォルトのスタイル
 */
export const DEFAULT_STYLE = {
  borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  borderRadius: 0,
  "& .MuiTableHead-root": {
    "& .MuiTableCell-root": {
      p: 2,
    },
  },
  "& .MuiTableBody-root": {
    "& .MuiTableCell-root": {
      px: 2,
      py: 3,
    },
  },
};

/**
 * {@link ReportTableContainer} のプロパティ
 */
export type ReportTableContainerProps = TableContainerProps;

/**
 * lite のレポート用の {@link TableContainer}
 * @see TableContainer
 */
export function ReportTableContainer(props: ReportTableContainerProps) {
  const { sx, ...rest } = props;
  return <TableContainer sx={{ ...DEFAULT_STYLE, ...sx }} {...rest} />;
}
